import { render, staticRenderFns } from "./menu-header.vue?vue&type=template&id=c3eeb062"
import script from "./menu-header.vue?vue&type=script&lang=js"
export * from "./menu-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports